import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import withModal from '../WithModal';
import svgInline from '../../SvgInline/SvgInline';
import closeIcon from '../../../shared/assets/icon-close.svg';
import './ShareModal.css';

export function packToUrl(filters, sort, organizationId, includeFiltersAndSort, favorites) {
  const query = [
    `organization=${organizationId}`,
  ];
  if (includeFiltersAndSort) {
    ['buildings', 'sites'].forEach(propertyType => {
      query.push(`${propertyType}:filters=${encodeURIComponent(JSON.stringify(filters[propertyType]))}`);
      query.push(`${propertyType}:sort=${sort[propertyType].join(':')}`);
    });
  } else if (favorites) {
    ['buildings', 'sites'].forEach(propertyType => {
      query.push(`${propertyType}:filters=${encodeURIComponent(JSON.stringify(favorites[propertyType]))}`);
    });
  }

  return query.join('&');
}

export class ShareModalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
    this.handleCopyClick = this.handleCopyClick.bind(this);
  }

  handleCopyClick() {
    this.textInput.select();
    if (document.execCommand('copy')) {
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2000);
    }
  }

  render() {
    const {
      onModalClick,
      organizationId,
      includeFiltersAndSort,
      filters,
      sort,
      favorites,
    } = this.props;

    const { copied } = this.state;

    const { origin } = window.location;
    let { pathname } = window.location;
    if (favorites) {
      pathname = favorites.buildings.has('_id')
        ? '/buildings'
        : '/sites';
    }
    const link = `${origin}${pathname}?${packToUrl(filters, sort, organizationId, includeFiltersAndSort, favorites)}`;
    return (
      <div className="modal-wrapper share-modal">
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <div className="modal-header">
            <h2 className="modal-title">Share</h2>
            <a tabIndex="0" onClick={onModalClick}>
              <div className="modal-close">
                {svgInline(closeIcon)}
              </div>
            </a>
          </div>
        </ViewerPrimaryColorUserStyle>
        <div className="modal-body share-modal-form">
          <div className="share-modal-form-header">
            <h3>Use the link below to share this view</h3>
            <a tabIndex="0" className={copied ? 'copied' : ''} onClick={this.handleCopyClick}>{copied ? 'copied' : 'copy link'}</a>
          </div>
          <input type="text" readOnly value={link} ref={input => { this.textInput = input; }} />
        </div>
      </div>
    );
  }
}

ShareModalComponent.propTypes = {
  organizationId: PropTypes.string,
  onModalClick: PropTypes.func,
  includeFiltersAndSort: PropTypes.bool,
  filters: PropTypes.shape({
    buildings: PropTypes.object.isRequired,
    sites: PropTypes.object.isRequired,
  }),
  sort: PropTypes.shape({
    buildings: PropTypes.arrayOf(PropTypes.string).isRequired,
    sites: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  favorites: PropTypes.shape({
    buildings: PropTypes.object.isRequired,
    sites: PropTypes.object.isRequired,
  }),
};

const mapStateToProps = state => ({
  organizationId: state.organizationId,
  filters: {
    buildings: state.buildings.filters,
    sites: state.sites.filters,
  },
  sort: {
    buildings: state.buildings.sort,
    sites: state.sites.sort,
  },
});

export default withModal(connect(mapStateToProps)(ShareModalComponent), 'share-map');



// WEBPACK FOOTER //
// ./src/components/Modal/ShareModal/ShareModal.js